import { AnalyticsBrowser } from "@segment/analytics-next"
import {
  useEffect,
  useRef,
} from "react"
import { SegmentContext } from "./SegmentContext"
import { SegmentPageTracker } from "./SegmentPageTracker"
import {
  useAccount,
  useTrackingTechnologyConsent,
} from "src/hooks"
import {
  getDeviceRegion,
  isUS,
} from "src/utils"

type Props = {
  children: React.ReactNode;
}

// note we are checking device region not account region
const isUSDevice = isUS(getDeviceRegion())

export function SegmentContextProvider(props: Props) {
  const { children } = props

  const { data: account } = useAccount()
  const [trackingTechnologyConsentResponse] = useTrackingTechnologyConsent()

  const analyticsRef = useRef<AnalyticsBrowser>(new AnalyticsBrowser())

  const shouldTrack =
    process.env.NODE_ENV !== "development" &&
    (isUSDevice || trackingTechnologyConsentResponse?.value === "accepted") &&
    account?.id

  useEffect(
    () => {
      if (!shouldTrack) {
        return
      }

      analyticsRef.current.load({
        writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY ?? "",
      })

      void analyticsRef.current.identify(account.id.toString())

      return () => {
        void analyticsRef.current.reset()
        analyticsRef.current = new AnalyticsBrowser()
      }
    },
    [
      account?.id,
      shouldTrack,
    ],
  )

  return (
    <SegmentContext.Provider value={analyticsRef}>
      {children}
      {shouldTrack && <SegmentPageTracker />}
    </SegmentContext.Provider>
  )
}
